<template>
  <div id="login">
    <section>
      <h3>Sign In</h3>
      <!-- This is a control built into Firebase Auth that allows Google/FB/Twitter integration directly.
       It is setup in the rux.js file -->
      <div id="firebaseui-auth-container"></div>
      <WhySignUp />
    </section>
    <div v-if="showPasswordReset">
      <PasswordReset />
      <div class="extras push-down-30">
        <div class="pointer" @click="togglePasswordReset()">Back to Log In</div>
      </div>
    </div>
    <section v-else>
      <div class="col2">
        <form v-if="loginForm.show" @submit.prevent>
          <h2>Or</h2>
          <div class="form-group">
            <label for="email1">Email</label>
            <input
              v-model.trim="loginForm.email"
              type="text"
              placeholder="you@email.com"
              id="email1"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label for="password1">Password</label>
            <input
              v-model.trim="loginForm.password"
              type="password"
              placeholder="∗∗∗∗∗∗∗∗"
              id="password1"
              class="form-control"
            />
          </div>
          <button @click="login" class="button pointer login-button">
            Log In
          </button>
          <div class="row extras push-down-20">
            <div class="col-6 pointer" @click="togglePasswordReset()">
              Forgot Password?
            </div>
            <div class="col-6 pointer" @click="toggleForm()">
              Create an Account
            </div>
          </div>
        </form>

        <form v-else @submit.prevent>
          <h2>Create your account</h2>
          <div class="form-group">
            <label for="name">Name</label>
            <input
              v-model.trim="signupForm.name"
              type="text"
              placeholder="Enter your name"
              id="name"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label for="email2">Email</label>
            <input
              v-model.trim="signupForm.email"
              type="text"
              placeholder="you@email.com"
              id="email"
              class="form-control"
            />
          </div>
          <div class="form-group">
            <label for="password2">Password</label>
            <input
              v-model.trim="signupForm.password"
              type="password"
              placeholder="8 characters minimum"
              id="password"
              class="form-control"
            />
          </div>
          <button @click="signUp()" class="button login-button pointer">Sign Up</button>
          <div class="extras push-down-20">
            <div class="pointer" @click="toggleForm()">Back to Log In</div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import PasswordReset from './PasswordReset'
import WhySignUp from './WhySignUp'
import { rux } from './../../lib/rux.js'
import { mapState } from 'vuex'

// Basic component that handles the login side. It uses both a Firebase email/password as well as integration with Google and FB
export default {
  name: 'Login',
  components: {
    PasswordReset,
    WhySignUp,
  },
  data: () => {
    return {
      loginForm: {
        email: '',
        password: '',
        show: true,
      },
      signupForm: {
        email: '',
        password: '',
        name: '',
      },
      showPasswordReset: false,
    }
  },
  computed: {
    ...mapState({ isAuth: (state) => state.auth.isAuth }),
  },
  methods: {
    async login() {
      // Perform the login with password/email here
      await this.$store.dispatch('auth/login', {
        email: this.loginForm.email,
        password: this.loginForm.password,
      })
      // Load all the RUX on successful Auth
      if (this.isAuth) {
        this.$store.dispatch('rux/getAllRux')
        this.$store.state.rux.ruxList.forEach(rux =>
          this.$store.dispatch('rux/checkReferralLink', rux.serialNumber)
        )
        this.redirectBack()
      }
    },
    async signUp() {
      // Not sure why this is here before signup
      this.$store.dispatch('rux/getAllRux')
      await this.$store.dispatch('auth/signUp', {
        email: this.signupForm.email,
        password: this.signupForm.password,
        name: this.signupForm.name,
      })
      // Once the user is authenticated redirect them back to where they were trying access before being sent to login page
      if (this.isAuth) {
        this.redirectBack()
      }
    },
    toggleForm() {
      this.loginForm.show = !this.loginForm.show
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset
    },
    redirectBack() {
      // In the router before being directed to the login page for a protected route, the initial request URL is appended.
      // This sends them back that way if it exists or to the homepage if not.
      if (this.$route.params.redirect) {
        this.$router.push(this.$route.params.redirect)
      } else {
        this.$router.push('/List')
      }
    },
  },
  mounted() {
    //Get the auto generated, standard login form from Firebase
    const redirect = this.$route.params.redirect || '/List'
    //const redirect = '/scan/v0/s1234/'
    //Set the redirect so the user goes back to the right place
    rux.getAuthUIConfig(redirect, '#firebaseui-auth-container')
  },
}
</script>

<style lang='scss' scoped>
@import '../../node_modules/firebaseui/dist/firebaseui.css';
div {
  font-family: "Neue Roman";
}
form {
  width: 95%;
  margin: 0 auto;
  @include respond-to('sm') {
    width: 75%;
  }
}
.form-group {
  text-align: left;
  label {
    margin-left: 0px;
    font-size: larger;
  }
}
h3 {
  padding-top: 40px;
  font-size: xx-large;
}
h2 {
  padding-top: 20px;
  padding-bottom: 10px;
}
// .form-control {
//   height: 50px;
//   font-family: "Neue Roman";
//   font-size: larger;
//   padding: 1rem;
// }
.extras {
  font-size: 1.1rem;
  div:hover {
    text-decoration: underline;
  }
}
.login-button {
  margin-top: 10px;
  margin-bottom: 20px;
}

</style>